import type { ApolloClientConfig } from '../types';

import {
	withAccessToken,
	withAuthMiddleware,
	withHeaders,
	withHttpLink,
	withUploadHttpLink,
	withSGHeader,
} from '@/graphql/utils/links';

import { withSentryTracing } from '@/libraries/sentry/graphql';

export function getServerLinks({ headers, pinia }: ApolloClientConfig) {
	return [
		withSGHeader(pinia),
		withAccessToken(pinia),
		withAuthMiddleware(pinia),
		withHeaders(headers),
		// withRetry(),
		withSentryTracing(),
		withHttpLink(),
	];
}

export function getClientLinks({ headers, pinia }: ApolloClientConfig) {
	const clientLinks = [withSGHeader(pinia), withAccessToken(pinia), withAuthMiddleware(pinia), withUploadHttpLink()];

	if (headers) {
		clientLinks.unshift(withHeaders(headers));
	}

	return clientLinks;
}
